import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";
import { InterestsTwoTone } from "@mui/icons-material";

interface SetGoldBalance {
    tlTutar: number;
}

async function setGoldBalance(data: SetGoldBalance): Promise<any> {
    try {
        return (await axiosInstance.post("/merchant/SetGoldBinding", data))
            .data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetMerchantSetGold() {
    return useMutation<any, Error, SetGoldBalance>(
        (variables) => setGoldBalance(variables)
    );
}
